module.exports = __webpack_public_path__ + "img/bb_g3_t_ears-05.4b1fec80.svg";